import { createBrowserHistory } from 'history';

export const history = createBrowserHistory({ basename: '/' });

export const defImg = 'placeholder.png';
export const destatuser = ['Placed', 'Accepted', 'Cancelled', 'Delivered', 'Declined'];
export const depaymenter = ['Unpaid', 'Offline', 'Online'];
export const minToMill = 60000;